import Modal from 'react-modal';
import React, { useState, useEffect, useCallback } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Grid, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import _isEmpty from 'lodash/isEmpty';
import { showProgress } from '../../redux/actions/DealershipActions';
import CollectionDetail from './CollectionDetail';
import service from '../../apis/service';
import { ErrorToast, generateVideoUrl, MultipleErrorToast, notifySuccess } from '../utils/Utils';
import { apiEndpoints } from '../../constants/apiEndpoints';
import CustomButton from '../shared/CustomButton';
import useCollection from './hooks/useCollection';
import { checkType, normalize, validateExploreCatPayload } from './utils';
import useCategory from '../categories/hooks/useCategory';
import { MODE } from './constants';

const customStyles = {
  content: {
    height: '88vh',
    width: '527px',
    padding: '0px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
};

const useStyles = makeStyles(() => ({
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  headerContainer: {
    padding: '20px',
  },
  footer: {
    padding: '12px',
  },
  cancelBtn: {
    marginRight: '6px',
  },
}));

function HandleCollectionCheckin(props) {
  const classes = useStyles();
  const { fetchCollections, fetchDepartments } = useCollection();
  const { mode, open, close } = props;
  const dispatch = useDispatch();
  const { fetchPartnerTypes } = useCategory();
  const [data, setData] = useState({});
  const [expLevelArr, setExpLevelArr] = useState([]);
  const [certificateImg, setCertificateImg] = useState('');
  const [certFileName, setCertFileName] = useState('');
  const [thumbnailImg, setThumbnailImg] = useState('');
  const [selectedValues, setSelectedValues] = useState([]);
  const [catList, setCatList] = useState([]);
  const [selectedCatValues, setSelectedCatValues] = useState([]);
  const [contentType, setContentType] = useState({
    type: 1,
    selectedItem: '',
    dueDate: null,
  });
  const [rnp, setRnp] = useState({});
  const [certificateImageData, setCertificateImageData] = useState();
  const [thumbnailImageData, setThumbnailImageData] = useState();
  const [originalAvPreview, setOriginalAvPreview] = useState(null);
  const departments = useSelector((state) => state.getAllDepartments.departments);
  const filters = useSelector((state) => state.getAddCollectionFilters.collectionfilters);
  const details = useSelector((state) => state.getCollection.collection);
  const categories = filters?.categories;
  const expertiseLevels = filters?.expertiseLevels;
  useEffect(() => {
    if (contentType?.type === 1 && rnp.ROCKED) {
      getExploreCategories();
      setSelectedCatValues([]);
    }
  }, [contentType?.type]);
  useEffect(() => {
    if (contentType?.selectedItem !== '' && rnp.ROCKED) {
      getExploreCategories();
      setSelectedCatValues([]);
    }
  }, [contentType?.selectedItem]);
  useEffect(() => {
    if (rnp.ROCKED) {
      getExploreCategories();
    }
  }, [data?.categories, rnp]);
  useEffect(() => {
    if (mode === 'edit' && !_isEmpty(details)) {
      const hasAvPreview = details?.avPreview && !_isEmpty(details.avPreview);
      setOriginalAvPreview(hasAvPreview ? details.avPreview : null);
      setData({
        ...details,
        categories: details?.categories?.map((item) => item.id),
        avPreview: hasAvPreview ? details.avPreview?.url || null : null,
      });
      setExpLevelArr(details?.expertiseLevel?.name);
      setThumbnailImg(details?.thumbnail);
      setThumbnailImageData(details?.thumbnail);
      setCertificateImg(details?.certificate);
      setCertificateImageData(details?.certificate);
      setContentType({
        type: details.contentType,
        selectedItem: details.rockedNetworkPartnerId || '',
        dueDate: details.dueDate || null,
      });
      setSelectedCatValues(details?.exploreCategories?.flatMap((item) => item.id));
    }
  }, [details]);

  const handleMultiSelectChange = (arr) => {
    setSelectedValues(arr);
    if (arr?.length === 0) {
      setCatList([]);
    }
    setData({ ...data, categories: arr });
  };
  const handleDataChange = ({ target }) => {
    if (target?.name === 'categories' || target?.name === 'expertiseLevel') {
      let temp = [];
      if (target?.name === 'categories') {
        temp = target.value?.map((val) => {
          const arr = categories.filter((item) => item.name === val);
          return arr[0];
        });
        setData({ ...data, [target?.name]: temp });
      } else {
        const value = expertiseLevels.filter((item) => item.id === target?.value);
        setData({ ...data, [target?.name]: value[0] });
        setExpLevelArr(target.value);
      }
    } else if (target?.name === 'accessOnAllJourneys' || target?.name === 'isEpg') {
      if (target?.name === 'accessOnAllJourneys' && data?.isEpg && !target?.checked) {
        ErrorToast('In Person Class is enabled for this collection.');
        return;
      }
      if (target?.name === 'isEpg') {
        if (mode === MODE.edit && data?.isEpg) {
          ErrorToast('In-person classes cannot be converted to normal collections.');
          return;
        }
        if (mode === MODE.edit && !data?.isEpg) {
          ErrorToast('Normal collections cannot be converted to  In-person classes.');
          return;
        }
        setData({ ...data, accessOnAllJourneys: target?.checked, [target?.name]: target?.checked });
        return;
      }
      setData({ ...data, [target?.name]: target?.checked });
    } else {
      setData({ ...data, [target?.name]: target?.value });
    }
  };

  const validateForm = () => {
    const errors = [];
    let formIsValid = true;
    if (!data.title) {
      formIsValid = false;
      errors.push('Please enter name.');
    }
    if (!data.goal) {
      formIsValid = false;
      errors.push('Please enter tagline');
    }
    if (!data.description) {
      formIsValid = false;
      errors.push('Please enter description.');
    }
    if (data.courseCode && data?.courseCode?.length > 15) {
      formIsValid = false;
      errors.push('Course code cannot exceed 15 characters.');
    }
    if (data.description && data.description?.length > 255) {
      formIsValid = false;
      errors.push('Collection description character limit is 255.');
    }
    if (!thumbnailImageData && mode !== 'edit') {
      formIsValid = false;
      errors.push('Please add a thumbnail');
    }
    if (!data.categories || data.categories?.length === 0) {
      formIsValid = false;
      errors.push('Please add atleast one department ');
    }
    if (!data.expertiseLevel) {
      formIsValid = false;
      errors.push('Please add the expertise level ');
    }

    if (contentType.type !== 1) {
      if (!contentType.selectedItem) {
        formIsValid = false;
        errors.push(`Please select ${contentType?.type === 2 ? 'an OEM' : 'a partner'} `);
      }
      const today = new Date();
      if (contentType.dueDate && contentType.dueDate <= today) {
        formIsValid = false;
        errors.push(`Please select a future date. `);
      }
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return formIsValid;
  };
  const handleGroupChange = (event) => {
    setSelectedCatValues(event.target.value);
  };
  const getExploreCategories = useCallback(async () => {
    if (data?.categories?.length > 0 && (rnp?.ROCKED || contentType.selectedItem)) {
      dispatch(showProgress(true));
      const deptIds = data?.categories?.map((id) => {
        const name = categories?.find((cat) => cat.id === id)?.name;
        const department = departments?.find((dept) => normalize(dept.title) === normalize(name));
        return department?.id;
      });
      const rnpIdCheck = validateExploreCatPayload(contentType, rnp);
      if (!rnpIdCheck) {
        dispatch(showProgress(false));
        ErrorToast(`Please select ${contentType?.type === 2 ? 'an OEM' : 'a partner'}`);
        return;
      }
      const payload = JSON.stringify({
        departments: deptIds?.filter(Boolean),
        rockedNetworkPartnerId: contentType.type !== 1 ? contentType.selectedItem : rnp.ROCKED[0]?.id || null,
      });
      await service
        .post(apiEndpoints.COLLECTION_EXPLORE_CAT, payload)
        .then((response) => {
          dispatch(showProgress(false));
          setCatList(response);
        })
        .catch((error) => {
          dispatch(showProgress(false));
          ErrorToast(error);
        });
    }
  }, [categories, contentType, data?.categories, departments, dispatch, rnp]);

  const submitCollection = async () => {
    const check = validateForm();
    if (check) {
      dispatch(showProgress(true));
      const formData = new global.FormData();
      formData.append('title', data.title);
      formData.append('goal', data.goal);
      formData.append('description', data.description);
      formData.append('expertiseLevel', data.expertiseLevel.id);
      data?.categories?.map((cat) => formData.append('categories', cat));
      selectedCatValues?.map((cat) => formData.append('exploreCategories', cat));
      if (data?.courseCode) {
        formData.append('courseCode', data?.courseCode);
      }
      if (data?.accessOnAllJourneys) {
        formData.append('accessOnAllJourneys', data?.accessOnAllJourneys);
      }
      if (certificateImageData) {
        formData.append('certificate', certificateImageData);
      }
      if (thumbnailImageData && checkType(thumbnailImageData)) {
        formData.append('thumbnail', thumbnailImageData);
      }
      if (data?.avPreview) {
        const hasOriginalAvPreview = originalAvPreview && !_isEmpty(originalAvPreview);
        const previewLinkValue =
          hasOriginalAvPreview && originalAvPreview?.url === data?.avPreview
            ? generateVideoUrl(originalAvPreview)
            : data?.avPreview;
        formData.append('previewVideoLink', previewLinkValue);
      }
      if (contentType.type === 1) {
        formData.append('rockedNetworkPartnerId', rnp?.ROCKED[0]?.id);
      } else {
        formData.append('rockedNetworkPartnerId', contentType.selectedItem);
        if (contentType.dueDate) {
          formData.append('dueDate', moment(contentType.dueDate).format('YYYY-MM-DD'));
        }
      }
      if (mode === MODE.add && data?.isEpg !== undefined) {
        formData.append('isEpg', data.isEpg);
      }
      if (mode === MODE.add) {
        await service
          .post(apiEndpoints.COLLECTION_CREATE, formData)
          .then(() => {
            dispatch(showProgress(false));
            close();
            notifySuccess('Saved Successfully');
            fetchCollections();
          })
          .catch((error) => {
            dispatch(showProgress(false));
            ErrorToast(error);
          });
      } else {
        await service
          .put(apiEndpoints.COLLECTION_UPDATE.replace('COLLECTION_ID', details.id), formData)
          .then(() => {
            dispatch(showProgress(false));
            close();
            notifySuccess('Saved Successfully');
            fetchCollections();
            if (props?.fromCat) {
              fetchPartnerTypes();
            }
          })
          .catch((error) => {
            dispatch(showProgress(false));
            ErrorToast(error);
          });
      }
    }
  };

  const handleCertificateImageChange = (e) => {
    const filesData = e.target.files[0];
    setCertFileName(filesData?.name);
    setCertificateImageData(filesData);
    const reader = new global.FileReader();
    reader.onload = (ev) => {
      setCertificateImg(ev.target.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };
  const handleThumbnailImageChange = (e) => {
    const filesData = e.target.files[0];
    setThumbnailImageData(filesData);
    const reader = new global.FileReader();
    reader.onload = (ev) => {
      setThumbnailImg(ev.target.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const handleDeleteImage = () => {
    setCertificateImg(null);
    setCertificateImageData(null);
    setCertFileName('');
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      dispatch(showProgress(true));
      await submitCollection();
      dispatch(showProgress(false));
    } catch (error) {
      dispatch(showProgress(false));
      ErrorToast(error);
    }
  };

  const getRNP = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.COLLECTION_RNP);
      setRnp(res || {});
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    getRNP();
    fetchDepartments();
  }, []);

  return (
    <Modal isOpen={open} onRequestClose={close} style={customStyles}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
        className={classes.headerContainer}
      >
        <Grid item>
          <Grid item className={classes.popupHeading}>
            {mode === 'add' ? 'Add Collection' : 'Edit Collection'}
          </Grid>
        </Grid>
        <Grid item>
          <CloseIcon onClick={close} style={{ cursor: 'pointer' }} />
        </Grid>
      </Grid>

      <CollectionDetail
        handleMultiSelectChange={handleMultiSelectChange}
        handleChange={handleDataChange}
        data={data}
        list={categories || []}
        catList={catList || []}
        mainArr={data?.categories || []}
        expValue={expLevelArr}
        expList={expertiseLevels}
        handleImageUploadNew={handleCertificateImageChange}
        handleThumbnailUpload={handleThumbnailImageChange}
        certificateImg={certificateImg || ''}
        thumbnailImg={thumbnailImg || ''}
        setCertificateImageData={setCertificateImageData}
        setCertificateImg={setCertificateImg}
        setContentType={setContentType}
        contentType={contentType}
        selectedValues={selectedValues}
        selectedCatValues={selectedCatValues}
        handleGroupChange={handleGroupChange}
        rnp={rnp}
        handleDeleteImage={handleDeleteImage}
        certFileName={certFileName}
        mode={mode}
      />

      <Grid container direction="row" justifyContent="flex-end" alignItems="center" className={classes.footer}>
        <Grid item className={classes.cancelBtn}>
          <CustomButton type="secondary" onClick={close} label="Cancel" />
        </Grid>
        <Grid item>
          <CustomButton type="primary" onClick={handleSubmit} label="Save" />
        </Grid>
      </Grid>
    </Modal>
  );
}

export default HandleCollectionCheckin;
